<template>
    <div class="tab-panel padded">


        <agent-form @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave" :passedForm="form"></agent-form>

        <div class="d-flex align-items-center justify-content-end" v-if="showButtons">
            <div>
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import AgentForm from './AgentForm'

    import mixpanelMixin from '@/mixins/mixpanel'

    export default {
        mixins: [
            mixpanelMixin
        ],
        data: function() {
            return {
                isDisabled: true,
                form: {},
            }
        },
        props: {
            showButtons: {
                default: true
            },
            agent: {
                default: null
            }
        },
        created: function() {
            if(this.agent){
                this.form = this.agent;
            }else if (this.getClonedAgent && this.getClonedAgent.id !== undefined) {
                this.form = JSON.parse(JSON.stringify(this.getClonedAgent));
            }

            // Landed directly on commissions from edit mode

            else if (this.getSelectedPerson) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedPerson));
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'updateAgent',
                'updateClonedAgent',
                'clearSelectedPerson',
                'getOtaAgentInfo',
                'updateOtaAgentInfo'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            cancel: function() {
                console.log('Cancelling edition');
                this.clearSelectedPerson();
            },
            readyToSave: function(updatedForm) {
                this.form = updatedForm;
            },
            save: function() {
                //if is OTA we use a different save method
                if(this.form.isOTA){
                    this.updateOtaAgentInfo(this.form)
                    this.trackSaveChanges('AgentOTA', this.form.id, this.form.brandName)
                } else {

                    console.log('edit save');
                    this.trackSaveChanges('Agent', this.form.id, this.form.brandName)
                    this.updateAgent({
                        agent: this.form
                    });

                }
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getClonedAgent'
            ])
        },
        components: {
            AgentForm
        }
    }

</script>



// WEBPACK FOOTER //
// AgentEdit.vue?42a74192